export const Language = {
  ENGLISH: 'EN_US',
  SPANISH: 'ES_US'
};

export const Locale = {
  ENGLISH: 'en-US',
  SPANISH: 'es-US'
};

export const CharacterType = {
  PRINT: 'print',
  CURSIVE: 'cursive',
  NUMBER: 'number'
};

export const CharacterCase = {
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase'
};

export const AnimationType = {
  FROG_JUMP: 'frogJump',
  DIVE_DOWN_DEEP: 'diveDownDeep',
  DIVE_DOWN: 'diveDown',
  BUMP: 'bump',
  BUMP_INNER: 'bumpInner',
  BASEBALL: 'baseball',
  HELICOPTER: 'helicopter',
  HIGH_HELICOPTER: 'highHelicopter',
  JET: 'jet',
  KARATE_KICK: 'karateKick',
  MAGIC_C: 'magicC',
  SLIDE_AWAY: 'slideAway',
  SLIDE_DOWN: 'slideDown',
  SLIDE_DOWN_REVERSED: 'slideDownReversed',
  FIREFIGHTER: 'firefighter',
  SMILE: 'smile',
  SWIM: 'swim',
  LONG_SWIM: 'longSwim',
  TOW: 'tow'
};

export const S3Prefix = {
  CURSIVE_UPPERCASE: 'CC',
  CURSIVE_LOWERCASE: 'lc',
  PRINT_UPPERCASE: 'PC',
  PRINT_LOWERCASE: 'PL'
};
